// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__MnZo_","disabled":"FileBtn_disabled__Us-F5","warn":"FileBtn_warn__GzH3i","fade":"FileBtn_fade__1I_90"};